import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import ContentCard from "../../common/template/contentCard";
import ContentCardHeader from "../../common/template/contentCardHeader";
import ContentCardBody from "../../common/template/contentCardBody";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import Button from "../../common/button/button";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
    getListaGraficoValorDevolvidoAnual,
    getListaGraficoValorDevolvidoMensalAno,
    getListaGraficoValorDevolvidoRessarcidoPeriodo,
    getListaGraficoValorDevolvidoPorUC,
    setFiltro,
} from "../analiseActions";
import { gerarRelatorio } from "../../fatura/faturaActions.js";

import { montarGraficoColumn } from "../../common/graficos/montarGraficoColumn.js";
import { montarGraficoPizza } from "../../common/graficos/montarGraficoPizza.js";
import { montarGraficoHorizontalBar } from "../../common/graficos/montarGraficoHorizontalBar.js";
import { convertToBase64 } from "../../utils/convertToBase64.js";
import { setInfo } from "../../common/toast/toast.jsx";
import { ModalAlert } from "../../common/dialog/modalAlert.jsx";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox.jsx";
import { Loading } from "../../common/loading/loading.jsx";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar.js";
import Td from "../../common/table/td.jsx";
import Tr from "../../common/table/tr.jsx";
import TBody from "../../common/table/tBody.jsx";
import Th from "../../common/table/th.jsx";
import THead from "../../common/table/tHead.jsx";
import Table from "../../common/table/table.jsx";

function analiseDevolucaoRessarcimento(props) {

    if(!props.visible) return null;
    
    const {
        state,
        listaGraficoValorDevolvidoAnual,
        listaGraficoValorDevolvidoMensalAno,
        listaGraficoValorDevolvidoRessarcidoPeriodo,
        listaGraficoValorDevolvidoPorUC,
        filtro,
        gerarRelatorio,
        getListaGraficoValorDevolvidoAnual,
        getListaGraficoValorDevolvidoMensalAno,
        getListaGraficoValorDevolvidoRessarcidoPeriodo,
        getListaGraficoValorDevolvidoPorUC,
        setAguardando,
        setFiltro,
    } = props;

    const contentCardRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [modalExportacaoAberto, setModalExportacaoAberto] = useState(false);
    const [graficoValorDevolvidoAnual, setGraficoValorDevolvidoAnual] = useState(null);
    const [graficoValorDevolvidoMensalAno, setGraficoValorDevolvidoMensalAno] = useState(null);
    const [graficoValorDevolvidoRessarcidoPeriodo, setGraficoValorDevolvidoRessarcidoPeriodo] = useState(null);
    const [graficoValorDevolvidoPorUC, setGraficoValorDevolvidoPorUC] = useState(null);

    useEffect(() => {
        atualizarTodosGraficos();
        return desmontarTodosGraficos;
    }, []);

    useEffect(() => {
        const buscarDados = async () => {
            if (!state.aguardando) return;

            await Promise.all([
                getListaGraficoValorDevolvidoAnual(),
                getListaGraficoValorDevolvidoMensalAno(),
                getListaGraficoValorDevolvidoRessarcidoPeriodo(),
                getListaGraficoValorDevolvidoPorUC(),
            ]);

            setAguardando(false);
        };

        buscarDados();
        if (!state.aguardando) {
            atualizarTodosGraficos();
        }
    }, [state.aguardando]);

    function atualizarTodosGraficos() {
        atualizarListaGraficoValorDevolvidoAnual();
        atualizarListaGraficoValorDevolvidoMensalAno();
        atualizarListaGraficoValorDevolvidoRessarcidoPeriodo();
        atualizarListaGraficoValorDevolvidoPorUC();
    }
    function desmontarTodosGraficos() {
        if (graficoValorDevolvidoAnual) graficoValorDevolvidoAnual.dispose();
        if (graficoValorDevolvidoMensalAno) graficoValorDevolvidoMensalAno.dispose();
        if (graficoValorDevolvidoRessarcidoPeriodo) graficoValorDevolvidoRessarcidoPeriodo.dispose();
        if (graficoValorDevolvidoPorUC) graficoValorDevolvidoPorUC.dispose();
    }

    function atualizarListaGraficoValorDevolvidoAnual() {
        const graficoValorDevolvidoAnualAtualizado = montarGraficoColumn({
            state,
            component: graficoValorDevolvidoAnual,
            nome: "grafico-valor-devolvido-anual",
            dados: listaGraficoValorDevolvidoAnual,
            category: filtro.devolucao_ano_safra ? "ano_inicio_fim_safra" : "ano",
            value: "valor",
            titulo: `Valor Devolvido por ${filtro.devolucao_ano_safra ? "Safra" : "Ano"} (R$)`,
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoValorDevolvidoAnual(graficoValorDevolvidoAnualAtualizado);
    }

    function atualizarListaGraficoValorDevolvidoMensalAno() {
        const graficoValorDevolvidoMensalAnoAtualizado = montarGraficoColumn({
            state,
            component: graficoValorDevolvidoMensalAno,
            nome: "grafico-valor-devolvido-mensal-ano",
            dados: listaGraficoValorDevolvidoMensalAno,
            category: "mes",
            value: "valor",
            titulo: "Valor Devolvido por Mês (R$)",
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoValorDevolvidoMensalAno(graficoValorDevolvidoMensalAnoAtualizado);
    }

    function atualizarListaGraficoValorDevolvidoRessarcidoPeriodo() {
        const graficoValorDevolvidoRessarcidoPeriodoAtualizado = montarGraficoPizza({
            state,
            component: graficoValorDevolvidoRessarcidoPeriodo,
            nome: "grafico-valor-devolvido-ressarcido-periodo",
            dados: listaGraficoValorDevolvidoRessarcidoPeriodo,
            category: "tipo",
            value: "valor",
            titulo: "Devoluções x Ressarcimentos por Período (R$)",
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoValorDevolvidoRessarcidoPeriodo(graficoValorDevolvidoRessarcidoPeriodoAtualizado);
    }

    function atualizarListaGraficoValorDevolvidoPorUC() {
        const graficoValorDevolvidoPorUCAtualizado = montarGraficoHorizontalBar({
            component: graficoValorDevolvidoPorUC,
            chartDivId: "grafico-valor-devolvido-por-uc",
            category: "nome_unidade_consumidora",
            value: "valor",
            bullet: "valor",
            bulletPosition: "out",
            bulletColor: "#fff",
            lista: listaGraficoValorDevolvidoPorUC,
            titulo: "Valor Devolvido por UC no Período (R$)",
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoValorDevolvidoPorUC(graficoValorDevolvidoPorUCAtualizado);
    }

    //atualiza graficos individualmente quando sua lista for atualizada --------------------------------------

    useEffect(() => {
        atualizarListaGraficoValorDevolvidoMensalAno();
    }, [listaGraficoValorDevolvidoMensalAno.length]);

    useEffect(() => {
        atualizarListaGraficoValorDevolvidoRessarcidoPeriodo();
    }, [listaGraficoValorDevolvidoRessarcidoPeriodo.length]);

    useEffect(() => {
        atualizarListaGraficoValorDevolvidoPorUC();
    }, [listaGraficoValorDevolvidoPorUC.length]);

    //--------------------------------------------------------------------------------------------------------
    function bloquearScroll(e) {
        e.preventDefault();
    }

    function toggleScroll(bloquear) {
        if (bloquear) {
            document.body.style.overflowY = "hidden";
            window.addEventListener("wheel", bloquearScroll, { passive: false });
            window.addEventListener("touchmove", bloquearScroll, { passive: false });
        } else {
            document.body.style.overflowY = "auto";
            window.removeEventListener("wheel", bloquearScroll);
            window.removeEventListener("touchmove", bloquearScroll);
        }
    }

    async function handleExport({ graficosAtivos, quantidadeUCs }) {
        const ALTURA_MAX_CONTEUDO = 84;
        const condicaoGraficoPaginaInteira = quantidadeUCs > 20;
        const condicao3PorPagina = quantidadeUCs <= 7;
        const graficosPorPaginaEmFuncaoDeQuantidadeUCs = condicaoGraficoPaginaInteira ? 1 : condicao3PorPagina ? 3 : 2;

        setLoading(true);
        toggleScroll(true);
        const getTamanhoBase = () => {
            const zoomAtual = Math.floor(window.devicePixelRatio * 100);
            let tamanhoBase = 1750;
            if (window.innerWidth >= 768) {
                if (zoomAtual > 80 && zoomAtual <= 100) {
                    tamanhoBase = 1820;
                } else if (zoomAtual > 75 && zoomAtual <= 80) {
                    tamanhoBase = 1850;
                } else if (zoomAtual >= 70 && zoomAtual <= 75) {
                    tamanhoBase = 1900;
                } else if (zoomAtual >= 60 && zoomAtual <= 70) {
                    tamanhoBase = 2050;
                } else if (zoomAtual >= 50 && zoomAtual <= 60) {
                    tamanhoBase = 2450;
                } else if (zoomAtual < 50) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }

                if (zoomAtual > 100 && zoomAtual <= 110) {
                    tamanhoBase = 1850;
                } else if (zoomAtual > 110 && zoomAtual <= 125) {
                    tamanhoBase = 1870;
                } else if (zoomAtual > 125 && zoomAtual <= 150) {
                    tamanhoBase = 2500;
                } else if (zoomAtual > 150 && zoomAtual <= 175) {
                    tamanhoBase = 4900;
                } else if (zoomAtual > 175) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }
            }
            return tamanhoBase;
        };
        const calcularWidthGrafico = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.zoom = "0.70"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1200 - desconto + "px";
            } else {
                el.style.width = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
                if (getTamanhoBase() == 2500) {
                    el.style.paddingLeft = "70px";
                    el.style.width = 1180 - desconto + "px";
                }
                if (getTamanhoBase() == 4900) {
                    el.style.paddingLeft = "120px";
                    el.style.width = 1105 - desconto + "px";
                }
            }
        };

        const formatarGrafico = ({ el }) => {
            if (el) {
                el.style.marginTop = "0px";
                el.style.fontSize = "0.8rem";
                calcularWidthGrafico({ el });
                el.style.backgroundColor = "#30303d";
                el.style.overflowY = "hidden";
                const titulo = el.querySelectorAll("tspan");
                titulo.forEach((el, i) => {
                    if (el.textContent.includes("Devolvido") || el.textContent.includes("Devoluções x Ressarcimentos")) {
                        el.style.marginTop = "3rem";
                        el.style.fontSize = "1.6rem";
                        el.style.fontWeight = "bold";
                        el.setAttribute("x", el.textContent.length * 4 + "px"); // centraliza no meio do SVG
                        el.setAttribute("text-anchor", "middle");
                    }
                });
            }
        };

        const exibirTagOculta = ({ el, textAlign = "left", titulo = false }) => {
            if (el) {
                calcularWidthGrafico({ el, desconto: 20 });
                el.style.color = "#FFFFFF";
                el.style.fontSize = titulo ? "1.6rem" : "1rem";
                el.style.fontWeight = "bold";
                el.style.backgroundColor = "#30303d";
                el.style.visibility = "visible";
                el.style.marginBottom = "0px";
                el.style.marginTop = "10px";
                el.style.padding = "5px";
                el.style.textAlign = textAlign;
            }
        };
        const calcularWidthTabela = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.fontSize = "0.7rem";
                el.style.zoom = "0.60"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1500 - desconto + "px";
            } else {
                el.style.minWidth = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
            }
        };

        const formatarTabela = ({ el, heightCelula }) => {
            if (el) {
                calcularWidthTabela({ el });
                el.style.color = "#FFFFFF";
                el.style.backgroundColor = "#30303d";
                el.style.paddingTop = "50px";
                el.style.paddingBottom = "50px";
                el.style.borderCollapse = "collapse";
                el.style.border = "1px solid #666682";

                // Aplica bordas também às células (th, td)
                const celulas = el.querySelectorAll("th, td");
                celulas.forEach((celula) => {
                    if (heightCelula) {
                        celula.style.height = heightCelula;
                    }
                    celula.style.border = "1px solid #666682";
                    celula.style.padding = "8px"; // Adiciona padding para melhorar a aparência
                    celula.style.textAlign = "left";

                    // Remove botões dentro do próprio td (fora da div filha)
                    celula.querySelectorAll("button").forEach((btn) => btn.remove());
                });
            }
        };

        if (contentCardRef.current) {
            const condicaoUltrapassaPaginas = quantidadeUCs > 60 && graficosAtivos.includes("grafico-valor-devolvido-por-uc");
            const alturaGraficosUC = condicaoUltrapassaPaginas ? `fit-content` : `84%`;
            const alinhamentoVertical = quantidadeUCs > 10 ? "flex-start" : "center";

            // Altera a largura e cor de fundo do gráfico antes de renderizar o conteúdo
            // const tituloGraficoGeracaoAvaliacaoProducaoMensal = contentCardRef.current.querySelector("#tituloGraficoGeracaoAvaliacaoProducaoMensal");
            const graficoValorDevolvidoAnual = contentCardRef.current.querySelector("#grafico-valor-devolvido-anual");
            const graficoValorDevolvidoMensalAno = contentCardRef.current.querySelector("#grafico-valor-devolvido-mensal-ano");

            const periodoGraficoPizza = contentCardRef.current.querySelector("#periodoGraficoPizza");

            const graficoValorDevolvidoRessarcidoPeriodo = contentCardRef.current.querySelector("#grafico-valor-devolvido-ressarcido-periodo");

            const periodoValorDevolvidoPorUc = contentCardRef.current.querySelector("#periodo-valor-devolvido-por-uc");
            const tabelaValorDevolvidoPorUc = contentCardRef.current.querySelector("#tabela-valor-devolvido-por-uc");

            const qtdLinhasTabela = 58;

            formatarGrafico({ el: graficoValorDevolvidoAnual });
            formatarGrafico({ el: graficoValorDevolvidoMensalAno });

            exibirTagOculta({ el: periodoGraficoPizza, textAlign: "center" });
            formatarGrafico({ el: graficoValorDevolvidoRessarcidoPeriodo });

            exibirTagOculta({ el: periodoValorDevolvidoPorUc, textAlign: "center", titulo: true });
            formatarTabela({ el: tabelaValorDevolvidoPorUc, heightCelula: quantidadeUCs > qtdLinhasTabela ? "3rem" : null });

            function calcularAlturaGraficosUC({ condicaoUltrapassaPaginas, quantidadeUCs, quantidadeLimite }) {
                const paginasOcupadasMesmoGrafico = Math.ceil(quantidadeUCs / quantidadeLimite);

                let alturaGraficosUC = ALTURA_MAX_CONTEUDO / graficosPorPaginaEmFuncaoDeQuantidadeUCs;

                if (condicaoUltrapassaPaginas) {
                    let total = 0;

                    for (let i = 0; i < paginasOcupadasMesmoGrafico; i++) {
                        //na primeira pagina soma mais 4% pra compensar a falta do rodapé
                        if (i == 0) {
                            total += ALTURA_MAX_CONTEUDO + 4;
                        } else if (i > 0 && i < paginasOcupadasMesmoGrafico - 1) {
                            //se é pagina do meia conta 100%, pq não tem cabeçalho nem rodapé
                            total += ALTURA_MAX_CONTEUDO + 16;
                        } else if (i == paginasOcupadasMesmoGrafico - 1) {
                            //na última pagina soma mais 10% pra compensar a falta do cabeçalho
                            total += ALTURA_MAX_CONTEUDO + 10;
                        }
                    }

                    alturaGraficosUC = total;
                }

                return alturaGraficosUC;
            }

            const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
            const htmlCabecalho = `<div style="border: 1px solid #DDD; max-height:fit-content; font-family: Arial, sans-serif;">
                                            <div style="width:100%; height:10%;">
                                               <img src="${base64Cabecalho}" width="100%" />
                                           </div>`;

            const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
            const htmlRodape = `<div style="width:100%; height:4%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                                                       <img src="${base64Rodape}" width="100%" />
                                                   </div>
                                               </div> `;

            // Captura o HTML com os estilos atualizados
            const htmlGraficoValorDevolvidoAnual =
                graficosAtivos.includes("grafico-valor-devolvido-anual") && graficoValorDevolvidoAnual
                    ? `<div style="width:100%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoValorDevolvidoAnual.outerHTML +
                      "</div>"
                    : "";

            // Captura o HTML com os estilos atualizados
            const htmlGraficoValorDevolvidoMensalAno =
                graficosAtivos.includes("grafico-valor-devolvido-mensal-ano") && graficoValorDevolvidoMensalAno
                    ? `<div style="width:100%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoValorDevolvidoMensalAno.outerHTML +
                      "</div>"
                    : "";

            // Captura o HTML com os estilos atualizados
            const htmlGraficosPizza =
                graficosAtivos.includes("grafico-valor-devolvido-ressarcido-periodo") && graficoValorDevolvidoRessarcidoPeriodo
                    ? `<div style="width:100%; height:28%; margin-bottom:15px; background-color:#30303d">` +
                      `<div style="display:flex; flex-direction:row; align-items:center; height:10%; justify-content:center;">${periodoGraficoPizza.outerHTML}</div>` +
                      `<div style="display:flex; flex-direction:row; align-items:center; height:90%; justify-content:center;">${graficoValorDevolvidoRessarcidoPeriodo.outerHTML}</div>` +
                      "</div>"
                    : "";

            // // Captura o HTML com os estilos atualizados
            const htmlGraficoValorDevolvidoPorUc =
                graficosAtivos.includes("grafico-valor-devolvido-por-uc") && tabelaValorDevolvidoPorUc
                    ? `<div style="width:100%; height:${calcularAlturaGraficosUC({
                          condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela,
                          quantidadeUCs,
                          quantidadeLimite: qtdLinhasTabela,
                      })}%; display:flex; flex-direction:column; align-items: center; justify-content:${alinhamentoVertical}; background-color:#30303d;">` +
                      periodoValorDevolvidoPorUc.outerHTML +
                      tabelaValorDevolvidoPorUc.outerHTML +
                      "</div>"
                    : "";

            const graficos = [
                { h: 28, el: htmlGraficoValorDevolvidoAnual },
                { h: 28, el: htmlGraficoValorDevolvidoMensalAno },
                { h: 28, el: htmlGraficosPizza },
                {
                    h: calcularAlturaGraficosUC({
                        condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela,
                        quantidadeUCs,
                        quantidadeLimite: qtdLinhasTabela,
                    }),
                    el: htmlGraficoValorDevolvidoPorUc,
                },
            ].filter((g) => g.el);

            if (!graficos.length) {
                setLoading(false);
                toggleScroll(false);
                return;
            }

            const listaPaginas = [];
            for (const g of graficos) {
                if (!listaPaginas.length) {
                    listaPaginas.push({
                        indice: listaPaginas.length,
                        alturaAcumulada: g.h,
                        graficos: [g.el],
                    });
                } else {
                    const ultimaPaginaIncluida = listaPaginas[listaPaginas.length - 1];
                    if (ultimaPaginaIncluida.alturaAcumulada + g.h > ALTURA_MAX_CONTEUDO) {
                        listaPaginas.push({
                            indice: listaPaginas.length,
                            alturaAcumulada: g.h,
                            graficos: [g.el],
                        });
                    } else {
                        ultimaPaginaIncluida.alturaAcumulada += g.h;
                        ultimaPaginaIncluida.graficos.push(g.el);
                    }
                }
            }

            let html = "";

            listaPaginas.forEach((pagina) => {
                html += htmlCabecalho;
                pagina.graficos.forEach((grafico) => {
                    html += grafico;
                });
                if (pagina.alturaAcumulada < ALTURA_MAX_CONTEUDO) {
                    html += `<div style="width:100%; height:${ALTURA_MAX_CONTEUDO - pagina.alturaAcumulada}%"></div>`;
                }
                html += htmlRodape;
            });
            // Gera o relatório com o HTML atualizado
            await gerarRelatorio({
                html,
                landscape: false,
                scale: window.innerWidth < 768 ? 0.62 : window.devicePixelRatio * 0.4,
            });
            toggleScroll(false);
            setLoading(false);
        } else {
            console.error("ContentCard não está acessível.");
        }
    }

    const quantidadeUCs = listaGraficoValorDevolvidoPorUC.length || 0;

    return (
        <div ref={contentCardRef}>
            {loading ? (
                <>
                    <Loading />
                    <div style={{ height: "100vh", width: "100%" }}></div>
                </>
            ) : null}
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto" }}>
                    <Row alignRight style={{ paddingRight: 5 }}>
                        <Grid cols="12 12 2 2" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                style={{ width: window.innerWidth < 768 ? "50%" : 120 }}
                                text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Exportar</span>}
                                title="Exportar"
                                type={"light"}
                                icon={"fa fa-file-export"}
                                event={() => {
                                    if (!filtro.id_cliente) {
                                        return setInfo("Selecione um cliente e clique em atualizar antes de exportar");
                                    }
                                    setModalExportacaoAberto(true);
                                }}
                            />
                        </Grid>
                    </Row>
                    {modalExportacaoAberto ? (
                        <ModalAlert handleClose={() => setModalExportacaoAberto(false)} visibility={loading ? "hidden" : "visible"}>
                            <ExportAnalise
                                quantidadeUCs={quantidadeUCs}
                                listaGraficosDisponiveis={[
                                    "grafico-valor-devolvido-anual",
                                    "grafico-valor-devolvido-mensal-ano",
                                    "grafico-valor-devolvido-ressarcido-periodo",
                                    "grafico-valor-devolvido-por-uc",
                                ]}
                            />
                        </ModalAlert>
                    ) : null}
                    <div
                        id="grafico-valor-devolvido-anual"
                        style={{
                            width: "100%",
                            minWidth: 900,
                            height: 400,
                        }}
                    ></div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto" }}>
                    <div
                        id="grafico-valor-devolvido-mensal-ano"
                        style={{
                            width: "100%",
                            minWidth: 900,
                            height: 400,
                        }}
                    ></div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardHeader>
                    <Grid cols="12 12 12 12">
                        <Row>
                            <Grid cols="12 12 2 2">
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                    <DatePicker
                                        variant="inline"
                                        openTo="year"
                                        views={["year", "month"]}
                                        label="De"
                                        autoOk
                                        value={
                                            filtro.competencia_inicial_comparativo_devolucao_ressarcimento
                                                ? `${String(filtro.competencia_inicial_comparativo_devolucao_ressarcimento).substring(0, 4)}/${String(
                                                      filtro.competencia_inicial_comparativo_devolucao_ressarcimento
                                                  ).substring(4, 6)}/01 12:00:00`
                                                : null
                                        }
                                        onChange={(value) => {
                                            setFiltro({
                                                ...filtro,
                                                competencia_inicial_comparativo_devolucao_ressarcimento: value
                                                    ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                    : null,
                                            });
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid cols="12 12 2 2">
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                    <DatePicker
                                        variant="inline"
                                        openTo="year"
                                        views={["year", "month"]}
                                        label="Até"
                                        autoOk
                                        value={
                                            filtro.competencia_final_comparativo_devolucao_ressarcimento
                                                ? `${String(filtro.competencia_final_comparativo_devolucao_ressarcimento).substring(0, 4)}/${String(
                                                      filtro.competencia_final_comparativo_devolucao_ressarcimento
                                                  ).substring(4, 6)}/01 12:00:00`
                                                : null
                                        }
                                        onChange={(value) => {
                                            setFiltro({
                                                ...filtro,
                                                competencia_final_comparativo_devolucao_ressarcimento: value
                                                    ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                    : null,
                                            });
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid cols="12 12 2 2" style={{ paddingTop: 10 }}>
                                <Button text="Analisar" type={"primary"} icon={"fa fa-sync"} event={getListaGraficoValorDevolvidoRessarcidoPeriodo} />
                            </Grid>
                        </Row>
                    </Grid>
                </ContentCardHeader>
                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto" }}>
                    <Row>
                        <div id="periodoGraficoPizza" style={{ visibility: "hidden" }}>
                            {"Período: "}
                            {filtro.competencia_inicial_comparativo_devolucao_ressarcimento
                                ? `${String(filtro.competencia_inicial_comparativo_devolucao_ressarcimento).substring(4, 6)}/${String(
                                      filtro.competencia_inicial_comparativo_devolucao_ressarcimento
                                  ).substring(0, 4)}`
                                : "_________"}
                            {" à "}
                            {filtro.competencia_final_comparativo_devolucao_ressarcimento
                                ? `${String(filtro.competencia_final_comparativo_devolucao_ressarcimento).substring(4, 6)}/${String(
                                      filtro.competencia_final_comparativo_devolucao_ressarcimento
                                  ).substring(0, 4)}`
                                : "_________"}
                        </div>
                    </Row>
                    <div
                        id="grafico-valor-devolvido-ressarcido-periodo"
                        style={{
                            width: "100%",
                            minWidth: 900,
                            height: 400,
                        }}
                    ></div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardHeader>
                    <Grid cols="12 12 12 12">
                        <Row>
                            <Grid cols="12 12 2 2">
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                    <DatePicker
                                        variant="inline"
                                        openTo="year"
                                        views={["year", "month"]}
                                        label="De"
                                        autoOk
                                        value={
                                            filtro.competencia_inicial_devolucao_por_uc
                                                ? `${String(filtro.competencia_inicial_devolucao_por_uc).substring(0, 4)}/${String(
                                                      filtro.competencia_inicial_devolucao_por_uc
                                                  ).substring(4, 6)}/01 12:00:00`
                                                : null
                                        }
                                        onChange={(value) => {
                                            setFiltro({
                                                ...filtro,
                                                competencia_inicial_devolucao_por_uc: value
                                                    ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                    : null,
                                            });
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid cols="12 12 2 2">
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                    <DatePicker
                                        variant="inline"
                                        openTo="year"
                                        views={["year", "month"]}
                                        label="Até"
                                        autoOk
                                        value={
                                            filtro.competencia_final_devolucao_por_uc
                                                ? `${String(filtro.competencia_final_devolucao_por_uc).substring(0, 4)}/${String(
                                                      filtro.competencia_final_devolucao_por_uc
                                                  ).substring(4, 6)}/01 12:00:00`
                                                : null
                                        }
                                        onChange={(value) => {
                                            setFiltro({
                                                ...filtro,
                                                competencia_final_devolucao_por_uc: value
                                                    ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                    : null,
                                            });
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid cols="12 12 2 2" style={{ paddingTop: 10 }}>
                                <Button text="Analisar" type={"primary"} icon={"fa fa-sync"} event={getListaGraficoValorDevolvidoPorUC} />
                            </Grid>
                        </Row>
                    </Grid>
                </ContentCardHeader>
                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", maxHeight: 400 }}>
                    <div id="periodo-valor-devolvido-por-uc" style={{ visibility: "hidden", display: "flex", justifyContent: "center" }}>
                        <h4>{`Valor Devolvido por UC em ${filtro.ano_devolucao} (R$)`}</h4>
                    </div>
                    {modalExportacaoAberto && (
                        <Table
                            responsive
                            id="tabela-valor-devolvido-por-uc"
                            height={(listaGraficoValorDevolvidoPorUC || []).length * 50 < 400 ? 400 : listaGraficoValorDevolvidoPorUC.length * 50}
                        >
                            <THead>
                                <Tr>
                                    <Th>Unidade</Th>
                                    <Th></Th>
                                    <Th alignCenter>Valor (R$)</Th>
                                </Tr>
                            </THead>
                            <TBody>
                                {[...listaGraficoValorDevolvidoPorUC]
                                    .sort((a, b) => b.valor - a.valor)
                                    .map((item, i, array) => {
                                        const max = parseFloat(array[0].valor || 0); //o max é o valor do primeiro, que é o maior
                                        const barraPercentual = max > 0 ? (parseFloat(item.valor || 0) / max) * 100 : 0;

                                        // Intervalos de hue possíveis (neon azul/roxo/lilás + verde/amarelo fosforescente)
                                        const hueRanges = [
                                            [200, 300], // azul → roxo → lilás
                                            [70, 110], // verde-limão / amarelo-esverdeado fluorescente
                                        ];

                                        // Escolhe aleatoriamente um dos intervalos
                                        const [minHue, maxHue] = hueRanges[Math.floor(Math.random() * hueRanges.length)];
                                        const hue = minHue + Math.floor(Math.random() * (maxHue - minHue));

                                        const saturation = 90 + Math.floor(Math.random() * 10); // 90–100%
                                        const lightness = 60 + Math.floor(Math.random() * 20); // 60–80%

                                        const cor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

                                        return (
                                            <Tr key={item.nome_unidade_consumidora}>
                                                <Td color="#fff">{item.nome_unidade_consumidora}</Td>
                                                <Td width="40vw">
                                                    <div style={{ backgroundColor: cor, width: barraPercentual + "%", height: 20 }}></div>
                                                </Td>
                                                <Td alignCenter color="#fff">
                                                    R$ {adicionarPontosMilhar(parseFloat(item.valor || 0).toFixed(2))}
                                                </Td>
                                            </Tr>
                                        );
                                    })}
                            </TBody>
                        </Table>
                    )}
                    {!modalExportacaoAberto && (
                        <div
                            id="grafico-valor-devolvido-por-uc"
                            style={{
                                width: "100%",
                                minWidth: 900,
                                height: (listaGraficoValorDevolvidoPorUC || []).length * 50 < 400 ? 400 : listaGraficoValorDevolvidoPorUC.length * 50,
                            }}
                        ></div>
                    )}
                </ContentCardBody>
            </ContentCard>
        </div>
    );

    function ExportAnalise({ listaGraficosDisponiveis }) {
        const [graficosAtivos, setGraficosAtivos] = useState(listaGraficosDisponiveis);
        const todosMarcados = graficosAtivos.length === listaGraficosDisponiveis.length;
        const existeAlgumMarcado = !!graficosAtivos.length;

        return (
            <>
                <div className="d-flex flex-column justify-content-center align-items-center text-dark">
                    <p>Selecione os gráficos que deseja exportar</p>
                </div>
                <LabelAndCheckbox
                    style={{ color: todosMarcados ? "#c90028" : "#1454ff", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem", marginBottom: 25 }}
                    label={todosMarcados ? "Desmarcar Todos" : "Marcar Todos"}
                    onChange={(e) => setGraficosAtivos(todosMarcados ? [] : listaGraficosDisponiveis)}
                    value={todosMarcados}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="grafico-valor-devolvido-anual-checkbox"
                    label="Valor Devolvido por Ano (R$)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("grafico-valor-devolvido-anual")
                                ? graficosAtivos.filter((grafico) => grafico !== "grafico-valor-devolvido-anual")
                                : [...graficosAtivos, "grafico-valor-devolvido-anual"]
                        )
                    }
                    value={graficosAtivos.includes("grafico-valor-devolvido-anual")}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="grafico-valor-devolvido-mensal-ano-checkbox"
                    label="Valor Devolvido por Mês (R$)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("grafico-valor-devolvido-mensal-ano")
                                ? graficosAtivos.filter((grafico) => grafico !== "grafico-valor-devolvido-mensal-ano")
                                : [...graficosAtivos, "grafico-valor-devolvido-mensal-ano"]
                        )
                    }
                    value={graficosAtivos.includes("grafico-valor-devolvido-mensal-ano")}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="grafico-valor-devolvido-ressarcido-periodo-checkbox"
                    label="Devolução x Ressarcimento por Período (R$)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("grafico-valor-devolvido-ressarcido-periodo")
                                ? graficosAtivos.filter((grafico) => grafico !== "grafico-valor-devolvido-ressarcido-periodo")
                                : [...graficosAtivos, "grafico-valor-devolvido-ressarcido-periodo"]
                        )
                    }
                    value={graficosAtivos.includes("grafico-valor-devolvido-ressarcido-periodo")}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="grafico-valor-devolvido-por-uc-checkbox"
                    label="Valor Devolvido por UC no Período (R$)"
                    onChange={(e) =>
                        setGraficosAtivos(
                            graficosAtivos.includes("grafico-valor-devolvido-por-uc")
                                ? graficosAtivos.filter((grafico) => grafico !== "grafico-valor-devolvido-por-uc")
                                : [...graficosAtivos, "grafico-valor-devolvido-por-uc"]
                        )
                    }
                    value={graficosAtivos.includes("grafico-valor-devolvido-por-uc")}
                />
                <Row alignRight style={{ paddingRight: 5 }}>
                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Exportar</span>}
                            type={"info"}
                            icon={"fas fa-check"}
                            event={(e) => {
                                if (!existeAlgumMarcado) {
                                    return setInfo("Marque pelo menos um item para exportar");
                                }
                                handleExport({ graficosAtivos, quantidadeUCs });
                                setModalExportacaoAberto(false);
                            }}
                        />
                    </Grid>

                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Cancelar</span>}
                            type={"danger"}
                            event={() => setModalExportacaoAberto(false)}
                        />
                    </Grid>
                </Row>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    filtro: state.analise.filtro,
    listaGraficoValorDevolvidoAnual: state.analise.listaGraficoValorDevolvidoAnual,
    listaGraficoValorDevolvidoMensalAno: state.analise.listaGraficoValorDevolvidoMensalAno,
    listaGraficoValorDevolvidoRessarcidoPeriodo: state.analise.listaGraficoValorDevolvidoRessarcidoPeriodo,
    listaGraficoValorDevolvidoPorUC: state.analise.listaGraficoValorDevolvidoPorUC,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getListaGraficoValorDevolvidoAnual,
            getListaGraficoValorDevolvidoMensalAno,
            getListaGraficoValorDevolvidoRessarcidoPeriodo,
            getListaGraficoValorDevolvidoPorUC,
            gerarRelatorio,
            setFiltro,
        },
        dispatch
    );
const AnaliseDevolucaoRessarcimento = connect(mapStateToProps, mapDispatchToProps)(analiseDevolucaoRessarcimento);
export { AnaliseDevolucaoRessarcimento };
